<template>
  <q-banner
      v-bind="$attrs"
      :inline-actions="$isDesktop"
      rounded
      :class="classes"
  >
    <slot />
    <template v-slot:action>
      <slot name="actions" />
    </template>
  </q-banner>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'info'
    }
  },
  computed: {
    classes(){
      return `banner__outlined--${this.type}`
    }
  }
}
</script>
